import useMutationApi from 'src/api/useMutationApi';

const useRemoveShipmentSignature = () => {
  return useMutationApi<{ shipmentId: string }>({
    endpoint: 'qa/remove-shipment-signature',
    method: 'POST',
  });
};

export default useRemoveShipmentSignature;
